import { render, staticRenderFns } from "./EditProduk.vue?vue&type=template&id=63ab6ee4&"
import script from "./EditProduk.vue?vue&type=script&lang=js&"
export * from "./EditProduk.vue?vue&type=script&lang=js&"
import style0 from "./EditProduk.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./EditProduk.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports